export const FEATURE_NAME = '@zerops/zerops/feature/notification';
